import { render, staticRenderFns } from "./StandardChange.vue?vue&type=template&id=7bbf7916&scoped=true&"
import script from "./StandardChange.vue?vue&type=script&lang=js&"
export * from "./StandardChange.vue?vue&type=script&lang=js&"
import style0 from "./StandardChange.vue?vue&type=style&index=0&id=7bbf7916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbf7916",
  null
  
)

export default component.exports